// extracted by mini-css-extract-plugin
export default {"scoreContainer":"ReportScore_scoreContainer__zvhvs"};